import type { IconSvgObject } from './types';

const Location06Icon: IconSvgObject = [
  ["path", { d: "M15.5 10.8887C15.5 12.8217 13.933 14.3887 12 14.3887C10.067 14.3887 8.5 12.8217 8.5 10.8887C8.5 8.95571 10.067 7.3887 12 7.3887C13.933 7.3887 15.5 8.95571 15.5 10.8887Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12 2.3887C7.30558 2.3887 3.5 6.00656 3.5 10.4694C3.5 15.3299 8.21916 17.7579 11.1092 21.1947C11.5669 21.7389 12.4531 21.7533 12.9211 21.2179C15.8645 17.8501 20.5 15.2362 20.5 10.4694C20.5 6.00656 16.6944 2.3887 12 2.3887Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default Location06Icon;
